import {createFileRoute, stripSearchParams} from '@tanstack/react-router'
import {type} from 'arktype'

import {fallbackToDefault} from '@/utils/schema/fallback'
import searchParamString from '@/utils/schema/searchParamString'

const DEFAULT_VALUES = {
  lng: 0,
  lat: 1,
  address: '',
  user_street_num: '',
  user_street_name: '',
  user_city: '',
  user_state: '',
  user_zipcode: '',
  user_country: '',
  page: 1,
}

const indexSearchSchema = type({
  lng: fallbackToDefault(type('number'), DEFAULT_VALUES.lng),
  lat: fallbackToDefault(type('number > 0 '), DEFAULT_VALUES.lat),
  address: searchParamString.default(DEFAULT_VALUES.address),
  user_street_num: searchParamString.default(DEFAULT_VALUES.user_street_num),
  user_street_name: searchParamString.default(DEFAULT_VALUES.user_street_name),
  user_city: searchParamString.default(DEFAULT_VALUES.user_city),
  user_state: searchParamString.default(DEFAULT_VALUES.user_state),
  user_zipcode: searchParamString.default(DEFAULT_VALUES.user_zipcode),
  user_country: searchParamString.default(DEFAULT_VALUES.user_country),
  page: fallbackToDefault(type('number > 0 '), DEFAULT_VALUES.page),
})

export const Route = createFileRoute('/_food-grubhub/food/')({
  validateSearch: indexSearchSchema,
  search: {
    middlewares: [stripSearchParams(DEFAULT_VALUES)],
  },
})
